module.exports = __webpack_public_path__ + "c89ed68ac8ea8879ad533f54957875b8.svg";